let scriptPromise: Promise<void> | null = null

export const loadConektaScript = (): Promise<void> => {
  if (scriptPromise) return scriptPromise
  scriptPromise = new Promise<void>((resolve, reject) => {
    if (window.ConektaCheckoutComponents) { resolve(); return }
    const script = document.createElement("script")
    script.src = "https://pay.conekta.com/v1.0/js/conekta-checkout.min.js"
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      scriptPromise = null
      reject(new Error("Failed to load Conekta SDK"))
    }
    document.head.appendChild(script)
  })
  return scriptPromise
}

export const mountConektaWidget = (params: {
  containerId: string
  checkoutRequestId: string
  publicKey: string
  onFinalize: () => void
}): (() => void) => {
  let attempts = 0
  const interval = setInterval(() => {
    const container = document.querySelector(`#${params.containerId}`)
    if (container && window.ConektaCheckoutComponents) {
      clearInterval(interval)
      try {
        window.ConektaCheckoutComponents.Integration({
          targetIFrame: `#${params.containerId}`,
          checkoutRequestId: params.checkoutRequestId,
          publicKey: params.publicKey,
          onFinalizePayment: params.onFinalize,
          options: {},
          styles: {},
        })
      } catch (err) {
        console.error("Conekta Integration Error:", err)
      }
    }
    if (++attempts > 50) {
      clearInterval(interval)
      console.error("Conekta container or SDK not found after 5 seconds")
    }
  }, 100)

  return () => clearInterval(interval)
}
